import React from 'react';
import AvatarEyes from './AvatarEyes';

const INK = '#292332';
const WHITE = '#FFFEFA';
const MOUTH = '#482735';
const TONGUE = '#E78495';
const TEAR = '#55BAEE';

const EXPRESSIONS = {
  happy_01: {
    leftBrow: 'M-53 -29 Q-37 -37 -22 -29',
    rightBrow: 'M22 -29 Q37 -37 53 -29',
    eyeStyle: 'open',
    mouthStyle: 'smile',
  },

  sad_01: {
    leftBrow: 'M-54 -25 Q-37 -26 -22 -36',
    rightBrow: 'M22 -36 Q37 -26 54 -25',
    eyeStyle: 'sad',
    mouthStyle: 'frown',
  },

  angry_01: {
    leftBrow: 'M-55 -32 L-21 -20',
    rightBrow: 'M21 -20 L55 -32',
    eyeStyle: 'angry',
    mouthStyle: 'tense',
  },

  shocked_01: {
    leftBrow: 'M-54 -36 Q-37 -49 -21 -37',
    rightBrow: 'M21 -37 Q37 -49 54 -36',
    eyeStyle: 'wide',
    mouthStyle: 'round',
  },

  cool_01: {
    leftBrow: 'M-54 -31 Q-37 -41 -21 -32',
    rightBrow: 'M22 -27 Q38 -31 54 -27',
    eyeStyle: 'relaxed',
    mouthStyle: 'smirk',
  },

  crying_01: {
    leftBrow: 'M-54 -27 Q-37 -28 -22 -40',
    rightBrow: 'M22 -40 Q37 -28 54 -27',
    eyeStyle: 'squeezed',
    mouthStyle: 'cry',
    tears: true,
  },

  wink_01: {
    leftBrow: 'M-53 -31 Q-37 -40 -22 -31',
    rightBrow: 'M22 -25 Q37 -32 53 -25',
    leftEyeStyle: 'open',
    rightEyeStyle: 'closedHappy',
    mouthStyle: 'smile',
  },

  laughing_01: {
    leftBrow: 'M-53 -32 Q-37 -42 -22 -32',
    rightBrow: 'M22 -32 Q37 -42 53 -32',
    eyeStyle: 'closedHappy',
    mouthStyle: 'laugh',
  },

  love_01: {
    leftBrow: 'M-53 -33 Q-37 -42 -22 -33',
    rightBrow: 'M22 -33 Q37 -42 53 -33',
    eyeStyle: 'heart',
    mouthStyle: 'softSmile',
  },

  cheeky_01: {
    leftBrow: 'M-54 -34 Q-37 -44 -22 -34',
    rightBrow: 'M22 -27 Q37 -32 54 -27',
    eyeStyle: 'sideLook',
    mouthStyle: 'tongueOut',
  },

  sleepy_01: {
    leftBrow: 'M-53 -26 Q-37 -30 -22 -26',
    rightBrow: 'M22 -26 Q37 -30 53 -26',
    eyeStyle: 'sleepy',
    mouthStyle: 'yawn',
  },
};






function ExpressionTears() {
  return (
    <g>
      {[-49, 49].map((x) => (
        <g key={x} transform={`translate(${x} 12)`}>
          <path
            d="
              M0 0
              C-3 10 -9 24 -9 34
              C-9 47 9 47 9 34
              C9 24 3 10 0 0
              Z
            "
            fill={TEAR}
            stroke="#287FB7"
            strokeWidth="2"
            strokeLinejoin="round"
          />

          <path
            d="M-3 23 Q-6 34 -3 37"
            fill="none"
            stroke="#C9F1FF"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </g>
      ))}
    </g>
  );
}

function ExpressionMouth({ style, isFemale }) {
  return (
    <g transform={isFemale ? 'scale(0.92 1)' : undefined}>
      {style === 'smile' && (
        <>
          <path
            d="
              M-28 -5
              Q0 1 28 -5
              C24 26 -24 26 -28 -5
              Z
            "
            fill={MOUTH}
          />

          <path
            d="
              M-22 -2
              Q0 3 22 -2
              L19 6
              Q0 11 -19 6
              Z
            "
            fill={WHITE}
          />

          <path
            d="M-10 16 Q0 11 10 16 Q0 20 -10 16 Z"
            fill={TONGUE}
          />
        </>
      )}

      {style === 'frown' && (
        <path
          d="M-21 13 Q0 -11 21 13"
          fill="none"
          stroke={MOUTH}
          strokeWidth="7"
          strokeLinecap="round"
        />
      )}

      {style === 'tense' && (
        <path
          d="M-22 8 Q0 2 22 8"
          fill="none"
          stroke={MOUTH}
          strokeWidth="7"
          strokeLinecap="round"
        />
      )}

      {style === 'round' && (
        <>
          <ellipse
            cx="0"
            cy="7"
            rx="15"
            ry="20"
            fill={MOUTH}
          />

          <path
            d="M-8 21 Q0 13 8 21 Q0 26 -8 21 Z"
            fill={TONGUE}
          />
        </>
      )}

      {style === 'smirk' && (
        <path
          d="M-20 3 Q2 20 24 -3"
          fill="none"
          stroke={MOUTH}
          strokeWidth="7"
          strokeLinecap="round"
        />
      )}

      {style === 'cry' && (
        <>
          <path
            d="
              M-23 15
              C-21 -11 21 -11 23 15
              Q24 26 13 24
              Q0 18 -13 24
              Q-24 26 -23 15
              Z
            "
            fill={MOUTH}
          />

          <path
            d="M-12 20 Q0 10 12 20 Q0 17 -12 20 Z"
            fill={TONGUE}
          />
        </>
      )}

      {style === 'laugh' && (
        <>
          <path
            d="
              M-32 -5
              Q0 5 32 -5
              C29 37 -29 37 -32 -5
              Z
            "
            fill={MOUTH}
          />

          <path
            d="
              M-26 -1
              Q0 6 26 -1
              L22 9
              Q0 15 -22 9
              Z
            "
            fill={WHITE}
          />

          <path
            d="
              M-15 24
              Q0 12 15 24
              Q0 32 -15 24
              Z
            "
            fill={TONGUE}
          />
        </>
      )}

      {style === 'softSmile' && (
        <path
          d="M-22 1 Q0 25 22 1"
          fill="none"
          stroke={MOUTH}
          strokeWidth="6"
          strokeLinecap="round"
        />
      )}

      {style === 'tongueOut' && (
        <>
          <path
            d="
              M-25 -2
              Q0 5 25 -2
              C22 23 -22 23 -25 -2
              Z
            "
            fill={MOUTH}
          />

          <path
            d="
              M-2 10
              Q8 7 18 10
              L18 23
              C18 37 -2 37 -2 23
              Z
            "
            fill={TONGUE}
            stroke={MOUTH}
            strokeWidth="2"
            strokeLinejoin="round"
          />

          <path
            d="M8 13 L8 23"
            fill="none"
            stroke="#BB526B"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </>
      )}

      {style === 'yawn' && (
        <>
          <ellipse
            cx="0"
            cy="10"
            rx="10"
            ry="16"
            fill={MOUTH}
          />

          <path
            d="M-5 21 Q0 16 5 21 Q0 25 -5 21 Z"
            fill={TONGUE}
          />
        </>
      )}
    </g>
  );
}


export default function AvatarExpression({
  expression,
  characterType = 'human_male',
  skin,
  layout,
  eyeShape,
  eyeColor,
}) {

  const isFemale = characterType === 'human_female';

  const face =
    EXPRESSIONS[expression?.id] || EXPRESSIONS.happy_01;

  const centerX = layout?.centerX ?? 200;
  const eyeY = layout?.eyeY ?? 183;
  const mouthY = layout?.mouthY ?? 231;

  const faceSkin = skin || {
    shadow: '#A96940',
  };

  return (
    <g>
      <g transform={`translate(${centerX} ${eyeY})`}>
        <g
          fill="none"
          stroke={INK}
          strokeWidth={isFemale ? 5 : 7}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d={face.leftBrow} />
          <path d={face.rightBrow} />
        </g>


        <AvatarEyes
          x={-36}
          side="left"
          style={face.leftEyeStyle || face.eyeStyle}
          isFemale={isFemale}
          skin={faceSkin}
          eyeShape={eyeShape}
          eyeColor={eyeColor}
        />

        <AvatarEyes
          x={36}
          side="right"
          style={face.rightEyeStyle || face.eyeStyle}
          isFemale={isFemale}
          skin={faceSkin}
          eyeShape={eyeShape}
          eyeColor={eyeColor}
        />

        {/* Shared nose, positioned between the eyes and mouth. */}
        <path
          d="
            M0 22
            C-3 27 -10 34 -10 39
            C-10 49 10 49 10 39
            C10 34 3 27 0 22
            Z
          "
          fill={faceSkin.shadow}
        />

        {face.tears && <ExpressionTears />}
      </g>

      <g transform={`translate(${centerX} ${mouthY})`}>
        <ExpressionMouth
          style={face.mouthStyle}
          isFemale={isFemale}
        />
      </g>
    </g>
  );
}
